//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { CloseOutlined, MenuFoldOutlined, MenuUnfoldOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { CastForEducationOutlined, DescriptionOutlined, LocalLibraryOutlined, MenuBookOutlined, SchoolOutlined, StorageOutlined } from '@mui/icons-material';
//  -- Components ---------------------
import { Button, Drawer, Dropdown, Layout, Menu, Space } from 'antd';

//  -- Features -----------------------
import { get } from 'lodash';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
//  -- Thunks -------------------------
import { handleLogout } from 'store/auth/thunks';
import { useCurrentUser, useProfilePicturePicker, useUserProfileConfig } from "store/users/selectors";
import styled from 'styled-components';
//  -- Constants ----------------------
import { BarChartOutlined, HomeOutlined } from '@ant-design/icons';
import { CastForEducationSharp, ExitToApp, KeyboardArrowDown, Settings } from '@mui/icons-material';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import TeacherWhatsNewModal from 'modules/WhatsNew/teacherWhatsNewModal';
import moment from 'moment-timezone';
import queryString from 'query-string';
import { handleInvokeFeedbackForm } from 'store/feedback/thunks';
import { useCurrentOrg } from "store/organizations/selectors";
import { handleCreateDontWhatsNew } from 'store/whatsNew/thunks';
import { userImg } from "utils/assets/images";
import { getAvatar } from 'utils/assets/images/lootie';
import COLOR from 'utils/constants/color';
import { apis } from 'utils/lib/apis';
import { impersonateTeacher } from 'store/keystore/thunks';
import SpinLoader from 'components/Loader/SpinLoader';
import ViewUserInfoModal from 'components/ViewUserInfoModal';
const { Header, Sider, Content } = Layout;


function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
}

const routes = {
    home: '/district',
    dataBrowsers: '/data-browsers',
    literacy_purpose: '/literacy',
    proficiency: '/proficiency-report',
    proficiencyMain: '/proficiency',
    contentExams:"/content_exam",
    standardExams: "/standard-exam",
    standardExamsReport: "/standard-exam-report",  
    'apExams': '/ap_exams',
    placement_exam_list:'/placement_exam_list',
    ebook_list:'/ebook_list'
};


const SideNavSection = styled.div`
`;


const OverviewText = styled.span`
  color: #fff;
  font-size: 19px;
  font-weight: 600;
  display:flex !important;
  align-items:center;
`;
const DistnameText = styled.div`
    color: #fff;
    display: flex !important;
    align-items: center;
    padding-left: 18px;
    font-size: 13px;
    font-weight: 400;
    margin-top: -23px;
    margin-left: 9px;
`;
const RowContainer = styled.div`
    border-left: ${p => p.border && `1px solid ${COLOR.black700}`};
    margin-left: 10px;
    padding-left: 20px;
`;

const UserContainer = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
`;
const UserDetails = styled.div`
    display: none;
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 8px;

    @media (min-width: 768px) {
        display: flex;
    }
`;
const UserDetailsMob = styled.div`
    display: none;
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 8px;

    @media (max-width: 768px) {
        display: flex;
    }
`;



const UserName = styled.span`
    color: #fff;
    display: block;
    font-size: 11px;
    font-weight: 600;
    line-height: 14px;
    margin-bottom: 0px;
`;
const Wrappers = styled.div`
  height: 100%;
  width: 100%;
`;


const StyledMenu = styled(Menu)`
  .ant-menu-item-selected {
    background-color: rgb(96,179,249) !important;
    color: #fff !important;
    border-radius: 10px !important;
    
    .ant-menu-item-icon, .ant-menu-item-title {
      color: white !important;
    }
  }

  .ant-menu-item-icon, .ant-menu-item-title {
    color: rgb(96,179,249); // color for non-active icons and text
  }
`;

const MenuItem = styled(Menu.Item)`
  &.ant-menu-item {
    margin: 0 !important;
    border-radius: 10px;
    padding-left: 25px !important; // adjust padding to match your design
    padding-right: 25px !important;
    font-weight: bold;
    ::after {
        border-right:none !important;
    }
    // &:hover {
    //   background-color: #e6f7ff !important; // color when hovering over the item
    //   .ant-menu-item-icon, .ant-menu-item-title {
    //     color: rgb(96,179,249) !important;
    //   }
    // }
  }
`;
const StyledList = styled(List)`
  width: 250px;
  height: 100vh;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;
const StyledListItem = styled(ListItem)`
  padding-left: 20px;
  padding-right: 20px;
  &:hover {
    background-color: #f4f4f4;
  }
  &.Mui-selected, &.Mui-selected:hover {
    background-color: #blue;
    color: white;
  }
`;
const StyledListItemIcon = styled(ListItemIcon)`
  color: inherit;
`;

const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};
  
const getKeyByValue = (object, value) => {
    return Object.keys(object).find(key => object[key] === value);
  };
const NavigationMenu = ({ is_placement_admin_user, orgId }) => {
     const showAlert = useAlert();
    const [current, setCurrent] = useState('home');
    const location = useLocation();
  	const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleImpersonateTeacher = async () => {
        if (!orgId) {
            showAlert('Organization ID not found', 'error');
            return;
        }

        setLoading(true);
        try {
          const response = await impersonateTeacher(orgId);

            if (response && response.success && response.data && response.data.key) {
                const key = response.data.key;
                const url = `${window.location.origin}?key=${key}`;
                window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
                showAlert('Impersonate teacher opened in new window', 'success');
            } else {
                showAlert('Failed to generate impersonate key', 'error');
            }
        } catch (error) {
            console.error('Error impersonating teacher:', error);
            showAlert('Failed to impersonate teacher', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleClick = e => {
        
        if (isMobileDevice() && window.innerWidth < 568) {
            showAlert('ALERT : District admin is designed for larger screens and is not supported on smaller or mobile screens.', 'error')
          } else {
            console.log("Continue on desktop");
        }

        if (e.key === 'impersonate_teacher') {
            handleImpersonateTeacher();
            return;
        }

        setCurrent(e.key);
        onClick(e)
    };
    const onClick = ({ key }) => {
        const path = routes[key];
        if (path)   navigate(path);
    };
    useEffect(() => {
        const pathname = location.pathname
        const key = getKeyByValue(routes, pathname)
        if (key ) {
            if (key == 'standardExamsReport') {
                setCurrent('standardExams')
            }else if(key == 'proficiencyMain'){
                setCurrent('proficiency')
            }else{
            setCurrent(key)
            }
        }
    }, [location])
    if (is_placement_admin_user) {
        return (
            <>
                <SpinLoader dataloader={loading} />
                <StyledMenu onClick={handleClick} selectedKeys={[current]} mode="inline">
                    <MenuItem key="placement_exam_list" icon={<CastForEducationSharp style={{ fontSize: 18 }} />}>
                        Placement Exams
                    </MenuItem>
                </StyledMenu>
            </>
        )
    }
   
  return (
    <>
        <SpinLoader dataloader={loading} />
        <StyledMenu onClick={handleClick} selectedKeys={[current]} mode="inline">
      <MenuItem key="home" icon={<HomeOutlined style={{ fontSize: 18 }} />}>
        Home
      </MenuItem>
      <MenuItem key="dataBrowsers" icon={<StorageOutlined  style={{ fontSize: 18 }} />}>
        Data Browser
      </MenuItem>
      <MenuItem key="ebook_list" icon={<MenuBookOutlined style={{ fontSize: 18 }} />}>
         Ebooks
      </MenuItem>
      <MenuItem key="proficiency" icon={<BarChartOutlined style={{ fontSize: 18 }} />}>
        Proficiency Exams
      </MenuItem>
      <MenuItem key="contentExams" icon={<DescriptionOutlined style={{ fontSize: 18 }} />}>
        Content Exams Report
      </MenuItem>
       <MenuItem key="standardExams" icon={<DescriptionOutlined style={{ fontSize: 18 }} />}>
        Standard Exams
      </MenuItem>
      {/* <MenuItem key="standardExamsReport" icon={<DescriptionOutlined style={{ fontSize: 18 }} />}>
        Standard Exams Report
      </MenuItem> */}
      <MenuItem key="apExams" icon={<SchoolOutlined style={{ fontSize: 18 }}  />}>
        AP Exams
      </MenuItem>
      <MenuItem key="literacy_purpose" icon={<LocalLibraryOutlined style={{ fontSize: 18 }} />}>
        Literacy with Purpose
      </MenuItem>
      <MenuItem key="placement_exam_list" icon={<CastForEducationOutlined style={{ fontSize: 18 }} />}>
         Placement Exams
      </MenuItem>
      <MenuItem key="impersonate_teacher" icon={<UserSwitchOutlined style={{ fontSize: 18 }} />}>
        Impersonate as Teacher
      </MenuItem>
    </StyledMenu>
    </>
  );
};

export default function District_admin({ children }) {
    const [placement, setPlacement] = useState('left');
    const [opens, setOpens] = useState(false);
    const currentUser = useCurrentUser()
    const currentOrg  = useCurrentOrg()
    const [collapsed, setCollapsed] = useState(false);
    const [showWhatsNewOpen, setShowWhatsNewOpen] = useState(false);
    const [dontLoader, setDontLoader] = useState(false);
    const viewInfoModalRef = useRef(null);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const search = queryString.parse(location.search);
    const { profile_config } = useUserProfileConfig()
    const { showProfilePhotoViewer } = useProfilePicturePicker()
    const toggleDrawer = () => setOpens(!opens);
    const toggleCollapse = () => setCollapsed(!collapsed);
    const is_placement_admin_user = useMemo(()=>currentUser?.role==='placement_admin',[currentUser])
    const is_act_as = useMemo(() => {
        return sessionStorage.getItem('act_as_user') === 'placement_admin';
    }, [])
    const has_blue_bg = useMemo(() => {
        const currentPath = location.pathname;
        const paths = ['/OneWayLessons', '/informate', '/resources', '/story-levels', '/ap', '/balconCultural', '/Conectandome','/comunidad','standard-based-exam']
        if (paths.includes(currentPath)) {
            return true;
        }
        return false;
    }, [location])
    const onClose = () => {
        setOpens(false);
    };

    const openWhatsNew = () => {
        const whats_new_shown = sessionStorage.getItem("whats_new_shown");
        if (whats_new_shown) return false;
        setShowWhatsNewOpen(true);
        sessionStorage.setItem("whats_new_shown",moment().toISOString());
        return true;
    }

    useEffect(() => {
        if (!showWhatsNewOpen) {
            openWhatsNew();
        }
    }, [])

    useEffect(() => {
        document.body.classList.add("setBgColor");
        // Optional: remove the class when component unmounts
        return () => {
            document.body.classList.remove("setBgColor");
        };
    }, []);
      

    const showDrawer = () => {
        setOpens(true);
    };
    const getRoute = () => {
        handleNavigate('/district');
    };
    const onLogOutPress = () => {
        dispatch(handleLogout());
        handleNavigate('/');
    }
    const handleNavigate = (path) => {
        navigate(path);
        setOpens(false)
    };

    const invokeFeedback = () => {
        dispatch(handleInvokeFeedbackForm())
    }
    const userNav = () => ({
        items: [
            {
                key: 'change-avatar',
                label: (
                    <Button className='menuBtnItem' type="text" onClick={showProfilePhotoViewer}>
                        Change Avatar
                    </Button>
                )
            },
        ...(
            document.referrer !== `${window.location.origin}/data-browsers?tab=district_admins` && document.referrer !== `${window.location.origin}/data-browsers?tab=district_admins_view`
                ? [{
                key: 'reset-password',
                label: (
                    <Button type="text" className='menuBtnItem' onClick={() => handleNavigate('/account')}>
                        Reset Password
                    </Button>
                )
            }, {
                key: 'view-info',
                label: (
                    <Button type="text" className='menuBtnItem' onClick={() => viewInfoModalRef.current?.open()}>
                        User info
                    </Button>
                )
            }]
            : []
        ),
            {
                key: 'report-issue',
                label: (
                    <Button className='menuBtnItem' type="text" onClick={invokeFeedback}>
                        Report an issue
                    </Button>
                )
            },
            {
                key: 'whats-new',
                label: (
                    <Button type="text" className='menuBtnItem' onClick={() => handleNavigate('/whats-new')}>
                        What's New
                    </Button>
                )
            },
            {
                key: 'logout',
                label: (
                    <Button className='menuBtnItem' type="text" onClick={onLogOutPress}>
                        Logout
                    </Button>
                )
            }
        ]
    });

    const settinguserNav = () => ({
        items: [
        ...(
        document.referrer !== `${window.location.origin}/data-browsers?tab=district_admins` && document.referrer !== `${window.location.origin}/data-browsers?tab=district_admins_view`
            ? [{
                key: 'reset-password',
                label: (
                    <Button type="text" onClick={() => handleNavigate('/account')}>
                        Reset Password
                    </Button>
                )
            }, {
                key: 'view-info',
                label: (
                    <Button type="text" onClick={() => viewInfoModalRef.current?.open()}>
                        User info
                    </Button>
                )
            }]
            : []
        ),
            {
                key: 'report-issue',
                label: (
                    <Button type="text" onClick={invokeFeedback}>
                        Report an issue
                    </Button>
                )
            }
        ]
    });

    const MenURanderer = useMemo(() => (<NavigationMenu is_placement_admin_user={is_placement_admin_user} orgId={currentOrg?.id} />), [search,is_placement_admin_user, currentOrg])
    const SettingRander = useMemo(() => {
        if(is_act_as) return null;
        return (<div style={{ }}>
            <Dropdown menu={settinguserNav()} placement="bottomRight" trigger={['click']}>
                <StyledListItem
                    button
                    onClick={(event) => { event.preventDefault() }}
                >
                    <StyledListItemIcon>
                        <Settings />
                    </StyledListItemIcon>
                    <ListItemText  primary="Settings" />
                </StyledListItem>
            </Dropdown>
            <StyledListItem
                button
                onClick={onLogOutPress}
            >
                <StyledListItemIcon>
                    <ExitToApp />
                </StyledListItemIcon>
                <ListItemText primary="Logout" />
            </StyledListItem>
        </div>)
    }, [currentUser,is_act_as])

    const getUserProfileImg = useMemo(() => {
        if (profile_config && profile_config.config) {
            const avt = getAvatar(profile_config.config.profile_pic)
            if (avt) {
                return avt
            }
        }
        return userImg;
    }, [profile_config])

    const onDontShowAgain = async (selected) => {
        const dontShowData = {
            id: selected?.id,
            user_id: currentUser?.id
        }
        setDontLoader(true);
        await dispatch(handleCreateDontWhatsNew(dontShowData))
        setDontLoader(false);
        setShowWhatsNewOpen(false);
    }
    
    return (
        <Wrappers>
             <TeacherWhatsNewModal open={showWhatsNewOpen} dontLoader={dontLoader} onClose={() => setShowWhatsNewOpen(false)} onDontShow={(val) => { 
                onDontShowAgain(val);
            }}
            />
            <Layout>
                <Drawer
                    title={get(currentOrg, 'displayName', '')}
                    placement={placement}
                    closable={false}
                    onClose={onClose}
                    open={opens}
                    key={placement}
                    width="378"
                    className="ownDrawer ownDrawerDistrict"
                    extra={
                        <Space>

                            <CloseOutlined onClick={onClose} style={{ color: 'white', fontSize: 20 }} />
                        </Space>
                    }
                >
                    <SideNavSection style={{ paddingLeft:5 , paddingRight:5 }}>
                    <div style={{ width: "100%", height: "80vh", display: "flex", flexDirection: "column", justifyContent: "space-between", paddingTop: 30, paddingBottom: 30, }}>
                    {MenURanderer}
                    {SettingRander}
                    </div>
                    </SideNavSection>
                </Drawer>

                <Sider
                    trigger={null}
                    width={250}
                    collapsible collapsed={collapsed}
                    className="hides left-menu-container"
                    style={{
                        background: "rgb(255,255,255)", 
                        paddingLeft: 5, 
                        paddingRight: 5
                    }}>
                    <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "space-between", paddingTop: 30, paddingBottom: 30, }}>
                        {MenURanderer}
                        {/* {SettingRander} */}
                    </div>
                </Sider>
                <Layout className='setBGSectionUpr'>
                <Header
                        className="cstmHeaderOld setBGSection districtAdminHeader"
                        style={{ backgroundImage:"none" , backgroundColor:"rgba(255,255,255)"}}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }} className="headDropdown">
                            <Button
                                className="hides"
                                type="text"
                                // icon=
                                onClick={toggleCollapse}
                                style={{
                                    fontSize: '16px',
                                    minWidth: 64,
                                    minHeight: 64,
                                    color: 'white'
                                }}
                            >
                                <OverviewText>
                                {collapsed ? <MenuUnfoldOutlined style={{ marginRight: '5px' }} /> : <MenuFoldOutlined style={{ marginRight: '5px' }} />}
                                    Welcome back,
                                 {get(currentUser, 'firstName', '')} {get(currentUser, 'lastName', '')}
                                 </OverviewText>
                            </Button>
                            <Button
                                className="unhides"
                                type="text"
                                // icon=
                                onClick={() => showDrawer()}
                                style={{
                                    fontSize: '16px',
                                    minWidth: 64,
                                    minHeight: 64,
                                    color: 'white'
                                }}
                            >
                                <OverviewText>{collapsed ? <MenuUnfoldOutlined style={{ marginRight: '5px' }} /> : <MenuFoldOutlined style={{ marginRight: '5px' }} />} 
                                Welcome back </OverviewText>
                            </Button>
                        </div>
                       {!is_act_as && <RowContainer style={{ marginRight: 10 }} className="usrDetailUpr" border={currentUser?.role === 'teacher' || currentUser?.role === 'admin'}>
                            <Dropdown className="usrDetailInr" menu={userNav()} placement="bottomRight" trigger={['click']}>
                                <UserContainer>
                                    <UserDetails className="usrDetail">
                                        <div className="usrDetailInfo" style={{ borderTop: 'none', borderBottom: 'none' }}>
                                            <div className="usrPic"><img src={getUserProfileImg} /></div>
                                            <div><UserName>{currentUser?.firstName} {currentUser?.lastName}</UserName></div>
                                            <div className="usrArrow"><KeyboardArrowDown style={{marginTop:"25px"}} /></div>
                                        </div>
                                    </UserDetails>
                                    <UserDetailsMob className="usrDetail">
                                        <div className="usrPic"><img src={getUserProfileImg} /></div>
                                    </UserDetailsMob>
                                </UserContainer>
                            </Dropdown>
                        </RowContainer>}
                    </Header>
                    <DistnameText className='districtAdminHeader-sub'> {get(currentOrg, 'displayName', '')}</DistnameText>
                    <Content className='booksListMain' style={{ background:has_blue_bg?'#0B1C2B':'white'}}>
                        {children}
                    </Content>
                </Layout>
            </Layout>
            <ViewUserInfoModal ref={viewInfoModalRef} />
        </Wrappers>
    )
}
